import React from "react";
import { ErrorMessage, Field, FieldArray, Form, Formik, isEmptyArray } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Recaptcha from 'react-recaptcha';

import { phoneRegex, numberQuantity } from "../../../validation/validation";
import { otherDevicesInquiry  } from "../../../services/otherDevicesService";
import { isEmpty } from "../../../validation/index";
import HowItWorks from '../../HowItWorks/HowItWorks'
import LoaderSpinner from "../../Loader/loaderSpinner";


const defaultsDevice = {
    deviceType: "",
    deviceCondition: "",
    deviceQuantity: "",
  };

  
const OtherDevices=(props)=>{
    const [isLoader, setIsLoader] = useState(false)
    const handleSubmit = (value) => {
      setIsLoader(true)
      const obj = {
        devices: value.devices,
        email: value.email,
        firstName: value.firstName,
        lastName: value.lastName,
        companyOrganization: value.companyOrganization,
        phoneNumber: value.phoneNumber,
        additionalInformation: value.additionalInformation,
      }
      otherDevicesInquiry(obj).then((res) => {
        setIsLoader(false)
        if (!isEmpty(res.data)) {
         window.location.href='/otherdevices-thank-you';
        }
      }).catch((err) => {
        console.log(err);
      })
    }
    const sellBulkSchema = Yup.object().shape({
        firstName: Yup.string()
          .required('Please input your first name!'),
        email: Yup.string()
          .email('Invalid email')
          .required('Please input your email!'),
        companyOrganization: Yup.string()
          .optional(),
        lastName: Yup.string()
         .optional(),
        phoneNumber: Yup.string()
          .matches(phoneRegex, 'Phone number must be 10 digit.')
          .required('Please input your phone number!'),
        additionalInformation: Yup.string()
          .optional(),
    
        devices: Yup.array()
          .of(
            Yup.object().shape({
              deviceType: Yup.string()
                .required('Required'),
              deviceCondition: Yup.string()
                .required('Required'),
              deviceQuantity: Yup.string()
                .matches(numberQuantity, "Please enter valid quantity")
                .required('Required'),
            })
          )
          .min(1, 'Minimum of 1 Device')
          .required('Required')
      })
    
      const initialValues = {
        devices: [defaultsDevice],
        firstName: '',
        email: '',
        lastName: '',
        companyOrganization: '',
        phoneNumber: '',
        additionalInformation: '',
        captcha: "",
      }
    
    
return(
  <div className="container p-2 mb-2">
    <div className="container-3" >
          <div className="text-center mt-2">
          
           <span style={{fontSize:18, fontWeight:700}}>Please share the details about the device you're looking to sell, since this device is not available in our product catalog, we may still be interested in it.</span>
          </div>
          <div className="mt-3 text-center"> 
          <span style={{fontSize:15, fontWeight:500}}>Fill the form below with your contact information and details about the device(s) you're looking to sell.</span>
          </div>
          <div className="mt-2">
         
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validationSchema={sellBulkSchema}
              render={({ values, setFieldValue, isSubmitting  }) => (
                <Form>
                  <FieldArray
                    name="devices"
                    render={arrayHelpers => (
                      <div className="container-2">
                      <a className="text-danger cursor-finger">* are mandatory fields.</a>    

                        <div className="row mt-5">
                          
                          <div className="col-md-6">
                            <div className="row">

                              <label className="col-md-12 mt-2">
                              <div className="text-danger">*<span className="text-dark">First Name:</span></div> 
                          </label>
                              <div className="col-md-12">
                                <Field className="form-control" type="text" name="firstName" />
                                <ErrorMessage name="firstName" className="text-danger" component="div" />
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-12 mt-2">
                              <div className="text-danger">*<span className="text-dark">Email:</span></div> 
                            </label>
                              <div className="col-md-12">
                                <Field className="form-control" type="text" name="email" />
                                <ErrorMessage name="email" className="text-danger" component="div" />
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-12 mt-2">
                                Company/Organization Name(optional):
                              </label>
                              <div className="col-md-12">
                                <Field className="form-control" type="text" name="companyOrganization" />
                                <ErrorMessage name="companyOrganization" className="text-danger" component="div" />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="row">
                              <label className="col-md-12 mt-2">
                                Last Name (optional):
                              </label>
                              <div className="col-md-12">
                                <Field className="form-control" type="text" name="lastName" />
                                <ErrorMessage name="lastName" className="text-danger" component="div" />
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-8 mt-2">
                              <div className="text-danger">*<span className="text-dark">Phone Number:</span></div> 
                              </label>
                              <div className="col-md-12">
                                <Field className="form-control" type="text" name="phoneNumber" />
                                <ErrorMessage name="phoneNumber" className="text-danger" component="div" />
                              </div>
                            </div>
                            <div className="row">
                              <label className="col-md-12 mt-2">
                                Additional Information (optional):
                              </label>
                              <div className="col-md-12">
                                <Field className="form-control" type="text" name="additionalInformation" />
                                <ErrorMessage name="additionalInformation" className="text-danger" component="div" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 text-center mt-4">
                          <h5>WHAT DO YOU HAVE TO SELL?</h5>
                        </div>
                        {values.devices && values.devices.length > 0 && (
                          values.devices.map((devices, index) => (
                            <div className="col-md-12" key={index}>
                              <div className="row">
                                <div className="col-md-3">
                                  <span className="text-danger">*</span>
                                  <label className="mt-2 ">
                                    Device Type:
                                </label>
                                  <div>
                                    <Field component="select" name={`devices[${index}].deviceType`} className="form-control">
                                      <option selected='true'>Choose a device type ...</option>
                                      <option value="Digital camera">Digital camera</option>
                                      <option value="Pc Laptop/Desktop">Pc Laptop/Desktop</option>
                                      <option value="Gaming PC/Desktop">Gaming PC/Desktop</option>
                                      <option value="Android Phones">Android Phones</option>
                                      <option value="iMacs">iMacs</option>
                                      <option value="MacMini">MacMini</option>
                                      <option value="Xbox">Xbox</option>
                                      <option value="Play Station">Play Station</option>
                                      <option value="Nintento">Nintento</option>
                                      <option value="Computer Accesories/Periphera">Computer Accesories/Peripheral</option>
                                      <option value="Other">Other</option>
                                    </Field>
                                    <ErrorMessage name={`devices[${index}].deviceType`} className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div className="col-md-3">
                                <span className="text-danger">*</span>
                                  <label className="mt-2">
                                    Condition:
                                  </label>
                                  <div>
                                    <Field component="select" name={`devices.${index}.deviceCondition`} className="form-control">
                                      <option value="" disabled>Choose a condition ...</option>
                                      <option value="Brand New">Brand New</option>
                                      <option value="Good">Good</option>
                                      <option value="Used">Used</option>
                                      <option value="Broken">Broken</option>
                                    </Field>
                                    <ErrorMessage name={`devices.${index}.deviceCondition`} className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div className="col-md-3">
                                <span className="text-danger">*</span>
                                  <label className="mt-2">
                                    Quantity:
                                  </label>
                                  <div>
                                    <Field className="form-control" type="text" name={`devices[${index}].deviceQuantity`} />
                                    <ErrorMessage name={`devices[${index}].deviceQuantity`} className="text-danger" component="div" />
                                  </div>
                                </div>
                                <div className="col-md-5">
                                <span className="text-danger">*</span>
                                <label className="mt-2">
                              Description of device (year,model,specs,etc.):
                            </label>
                              <div>
                                <Field className="form-control" type="textarea" name="description" />
                                <ErrorMessage name="description" className="text-danger" component="div" />
                              </div>
                            </div>

                                <div className="col-md-1 d-flex align-items-flex-end">
                                  {
                                    index !== 0 &&
                                    <span onClick={() => arrayHelpers.remove(index)} className="mt-2 text-danger"> <svg width="2em" height="2em" viewBox="0 0 16 16" className="bi bi-dash-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                      <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                      <path fill-rule="evenodd" d="M3.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5z" />
                                    </svg></span>
                                  }
                                </div>
                                <div className="col-md-1"></div>
                              </div>
                            </div>
                          ))
                        ) || null}
                        <div className="col-md-12 mt-3">
                          <div className="row">
                            <div className="col-md-1"></div>
                            <div className="col-md-10">
                              <button type="button" onClick={() => arrayHelpers.push(defaultsDevice)} className="btn btn-outline-info"> Add more devices</button>
                            </div>
                            <div className="col-md-1"></div>
                          </div>
                        </div>

                        <div className="col-md-12 mt-3">
                          <div className="row">
                            <div className="col-md-1"></div>
                            <div className="col-md-10">
                            {/* <Recaptcha
                                name="captcha"
                                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                render="explicit"
                                verifyCallback={(response) => {
                                  setFieldValue('captcha', response)
                                }}
                              />
                              <ErrorMessage name="captcha" className="text-danger" component="div" />***/}
                            </div>
                            <div className="col-md-1"></div>
                          </div>
                        </div>
                        <div className="col-md-12 mt-5">
                          <div className="d-flex justify-content-center ">
                            <button type="submit" className="mb-2 px-5 btn btn-outline-primary btn-lg"  disabled={isSubmitting}>
                              Submit
                            </button>
                          </div>
                          <div className="mt-5">
        
        </div>
        {isLoader && 
              <div className="text-center">
                  <LoaderSpinner></LoaderSpinner>
              </div>
      
          }
                        </div>
                      </div>
                      
                    )}
                  />
                  
                </Form>
                
              )}
            />
            
          </div>
        
        
        </div > 
  </div>
    
  )
}
export default OtherDevices